import * as React from "react";
import {useState} from "react";
import {Link} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import DataTable from 'react-data-table-component';
import {
    lpExtendedStatsColumns,
    lpExtendedStatsValues,
    mcStatsColumns,
    mcStatsValues,
    meStatsColumns,
    meStatsValues
} from "./RoleStats";
import {useRolesListQuery} from "../../../types.d";
import {CourseFilter} from "../../partials/CourseFilter";
import moment from "moment";

const registeredToDate = date => moment(date.split('.').reverse().join('-'))

export const RoleListPage = (props: RouteComponentProps<{ role: string }>) => {
    const [filter, setFilter] = useState('');
    const [selectedCourse, setSelectedCourse] = useState(0);
    const role = props.match.params.role.toUpperCase();

    let statsColumns;
    let values: (row) => any[];

    if (role === 'LP') {
        statsColumns = lpExtendedStatsColumns;
        values = lpExtendedStatsValues;
    }

    if (role === 'MC') {
        statsColumns = mcStatsColumns;
        values = mcStatsValues;
    }

    if (role === 'ME') {
        statsColumns = meStatsColumns;
        values = meStatsValues;
    }

    const response = useRolesListQuery({
        variables: { role, courseId: selectedCourse }
    });

    if (!response.data) {
        return null;
    }

    const roles = response.data.rolesList.filter(item => (
        !filter.length || item.name.includes(filter)
    ));

    const data = roles.filter(u => {
        return !selectedCourse || u.allowedCourses.includes('All') || u.allowedCourses.includes(selectedCourse + '')
    }).map(item => ({
        name: item.name,
        registered: item.registered,
        ...(values(item.stats.details).reduce((prev, current, index) => {
            prev[`stats_${index}`] = current;

            return prev;
        }, {})),
    }));
    const columns = [
        {
            name: 'User Name',
            selector: 'name',
            sortable: true,
        },
        {
            name: 'Registered',
            selector: 'registered',
            sortFunction: (a, b) => {
                return registeredToDate(a.registered).isAfter(registeredToDate(b.registered)) ? 1 : -1
            },
            sortable: true,
        },
        ...statsColumns.map((item, index) => ({
            name: item[2],
            selector: `stats_${index}`,
            sortable: true
        })),
    ];

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to="/stats-overview">Stats Overview</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">User quality metrics</li>
                </ol>
            </nav>

            <div className={'mb-3'}>
                <CourseFilter onChange={course => setSelectedCourse(course)} />
            </div>

            <DataTable
                title="User quality metrics"
                pagination={true}
                actions={<input
                    type={'text'}
                    onChange={e => setFilter(e.currentTarget.value)}
                    style={{ width: 240 }}
                    className={'form-control'}
                    placeholder={'Search...'} />}
                columns={columns}
                data={data}
            />
        </div>
    </div>
};
